import { useCallback, useEffect, useState } from "react";
import { getTemplate } from "../../../services/smsTemplateServices";
import { getGroupsOptions } from "../../../services/groupServices";
import { getLogs } from "../../../services/smsTemplateServices";
import SmsSendScheduleManager from "./SmsSendScheduleManager";

const SmsSendAndSchedule = () => {
  const [templates, setTemplates] = useState([]);
  const [groups, setGroups] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [lastId, setLastId] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);

  const [totalCount, setTotalCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = 10;

  const fetchPaginatedSchedule = async (direction, id) => {
    try {
      const response = await getLogs({
        lastId: id || undefined,
        limit: pageSize,
      });

      const messages = response.data.logs;
      const newLastId = response.data.lastId;
      const more = response.data.hasMore;
      const total = response.data.totalCount;

      setSchedule(messages);
      setLastId(newLastId);
      setHasMore(more);
      setTotalCount(total);

      setPageIndex((prev) =>
        direction === "next" ? prev + 1 : Math.max(prev - 1, 0)
      );
    } catch (error) {
      console.error("Failed to fetch scheduled messages:", error);
    }
  };

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    const [templatesResult, groupsResult] = await Promise.allSettled([
      getTemplate(),
      getGroupsOptions(),
    ]);

    if (templatesResult.status === "fulfilled") {
      setTemplates(templatesResult.value.data);
    }
    if (groupsResult.status === "fulfilled") {
      setGroups(groupsResult.value.data);
    }

    await fetchPaginatedSchedule("next");
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  if (loading)
    return (
      <div className="flex justify-center items-center text-black h-screen">
        Loading...
      </div>
    );

  return (
    <div className="h-screen !overflow-hidden">
      <SmsSendScheduleManager
        templates={templates}
        groups={groups}
        schedule={schedule}
        hasMore={hasMore}
        totalCount={totalCount}
        onLoadMore={fetchPaginatedSchedule}
        refreshSchedule={fetchAllData}
      />
    </div>
  );
};

export default SmsSendAndSchedule;
